module.exports = __webpack_public_path__ + "img/fajg1.fed948e1.png";